module.exports = __webpack_public_path__ + "img/97be597777b142698d4c159fc51d3e60.c99317b7.png";